// extracted by mini-css-extract-plugin
export default {"dateContainer":"EiqnYCfN6h"};